import axios from 'axios'
import {clarify} from "@/utils/clear";

class ProductApi {
  constructor() {
    this.endpoint = process.env.VUE_APP_BASE_API
  }

  list(body) {
    let params = new URLSearchParams(body ? clarify(body) : body)
    return axios.get(`${this.endpoint}/products`, {params}).then(response => response.data)
  }

  get(productId) {
    return axios.get(`${this.endpoint}/products/get/${productId}`, {}).then(response => response.data)
  }

  save(user) {
    return axios.post(`${this.endpoint}/products/save`, user).then(response => response.data)
  }

  delete(productId) {
    return axios.delete(`${this.endpoint}/products/delete/${productId}`, {}).then(response => response.data)
  }

}


export default new ProductApi()
